import React, { Component } from "react";
import { Form, Col, Input, Select, DatePicker } from "antd";
import moment from "moment";
import ListPage from "../../../../../components/ListPage";
import styles from "./index.less";

const { RangePicker } = DatePicker;
const { ListSearch } = ListPage;
const { Item } = Form;

const activityStatus = [
  {
    key: "",
    value: "全部"
  },
  {
    key: 0,
    value: "草稿"
  },
  {
    key: 1,
    value: "进行中"
  },
  {
    key: 2,
    value: "已结束"
  }
];

class HooksSearch extends Component {
  handleSubmit = values => {
    const { handleQueryChange, handleResetBizIdList } = this.props;
    const { time, status, activityName, activityType } = values;
    if (handleResetBizIdList) {
      handleResetBizIdList();
    }
    if (time) {
      const startTime = moment(time[0]).format("YYYY-MM-DD");
      const endTime = moment(time[1]).format("YYYY-MM-DD");
      handleQueryChange({
        query: { status, activityName, activityType, startTime, endTime }
      });
    } else {
      handleQueryChange({
        query: values
      });
    }
  };

  handleReset = () => {
    const { handleQueryChange, form, handleResetBizIdList } = this.props;
    const { resetFields, getFieldsValue } = form || {};
    resetFields();
    if (handleResetBizIdList) {
      handleResetBizIdList();
    }
    handleQueryChange({
      query: { ...getFieldsValue(), startTime: "", endTime: "" }
    });
  };

  render() {
    const { form, typeList } = this.props;
    const { getFieldDecorator } = form;
    const formItemLayout = {
      colon: true,
      labelCol: {
        xs: { span: 7 },
        sm: { span: 7 }
      },
      wrapperCol: {
        xs: { span: 17 },
        sm: { span: 17 }
      }
    };

    const searchProps = {
      form,
      btnSmSpan: 16,
      btnLgSpan: 16,
      handleQuery: this.handleSubmit,
      handleReset: this.handleReset,
      className: styles.root,
      buttonColProps: {
        style: {
          lineHeight: "unset",
          textAlign: "right"
        }
      }
    };

    return (
      <ListSearch {...searchProps}>
        <Col span={8} className="hooksSearch">
          <Item label="活动名称" {...formItemLayout}>
            {getFieldDecorator("activityName", {
              initialValue: ""
            })(<Input placeholder="请搜索活动名称" />)}
          </Item>
        </Col>
        <Col span={8} className="hooksSearch">
          <Item label="活动类型" {...formItemLayout}>
            {getFieldDecorator(`activityType`, {
              initialValue: ""
            })(
              <Select placeholder="请选择">
                <Select.Option value="">全部</Select.Option>
                {typeList &&
                  typeList.map(item => (
                    <option value={item.typeId}>{item.typeName}</option>
                  ))}
              </Select>
            )}
          </Item>
        </Col>
        <Col span={8} className="hooksSearch">
          <Item label="活动状态" {...formItemLayout}>
            {getFieldDecorator("status", {
              initialValue: ""
            })(
              <Select placeholder="请搜索活动标题">
                {activityStatus.map(item => {
                  return (
                    <Select.Option value={item.key}>{item.value}</Select.Option>
                  );
                })}
              </Select>
            )}
          </Item>
        </Col>
        <Col span={8} className="hooksSearch">
          <Item label="打卡时间" {...formItemLayout}>
            {getFieldDecorator("time", {
              initialValue: ""
            })(<RangePicker format="YYYY.MM.DD" />)}
          </Item>
        </Col>
      </ListSearch>
    );
  }
}

export default HooksSearch;
